import { Routes } from '@angular/router';

import { BlogArticleResolver } from '@shared/resolvers/blog-article-resolver';

export const wrapperRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('@pages/landing/landing.component')
      .then((m) => m.LandingComponent),
  },
  {
    path: 'blog',
    loadComponent: () => import('@pages/blog/blog/blog.component')
      .then((m) => m.BlogComponent),
  },
  {
    path: 'blog/:id',
    loadComponent: () => import('@pages/blog/blog-article/blog-article.component')
      .then((m) => m.BlogArticleComponent),
    resolve: { articleData: BlogArticleResolver },
  },
  {
    path: 'presentation',
    loadComponent: () => import('@pages/presentation/presentation.component')
      .then((m) => m.PresentationComponent),
  },
  {
    path: 'not-found',
    loadComponent: () => import('@pages/not-found/not-found.component')
      .then((m) => m.NotFoundComponent),
  },
];
